// extracted by mini-css-extract-plugin
module.exports = {"root":"AttivitaCard_root__4J_YE","cta":"AttivitaCard_cta__FPjPe","rotation":"AttivitaCard_rotation__KdtbZ"};